module.exports = __webpack_public_path__ + "static/media/new_flight_meta_CO_cover.1e99d913.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_flight_meta_CO_cover.png
// module id = 1441
// module chunks = 0